export enum DateSuggestionInterval {
    EarlierArrival = 'EarlierArrival',
    LaterDeparture = 'LaterDeparture',
    OtherDates = 'OtherDates',
}
